import React, { Fragment, useEffect, useState } from "react";
import "./index.scss";
import { Col, Row, Typography } from "antd";
import Information from "@components/Information";
import ProductDetail from "@components/ProductDetail";
import { useQuery, useQueryClient } from "react-query";
import { getBidProduct, getUpNextProduct } from "dataLayer/product";
import { getResultsProduct } from "@dataLayer/product";
import { getUserQuery, useDetectPhone } from "dataLayer/user";
import { useTranslation } from "react-i18next";
import EmptyData from "@components/EmptyData";
import { currentDate } from "@utils/utils";
import BidModal from "@components/Modal/BidModal";
import ChangeBid from "@components/Modal/NotifyChangeBid";
import PotentialWinner from "@components/PotentialWinner";
import { isDetected, isLoggedIn } from "@utils/cookie";
import flagGroup from "@assets/images/HomePage/flag-group.png";
import flag from "@assets/images/HomePage/flag.png";

const { Title } = Typography;

const HomePage = () => {
  const { data: products } = useQuery(getBidProduct());
  const { data: user } = useQuery(getUserQuery());
  const { data: upnexts } = useQuery(getUpNextProduct());
  const { t } = useTranslation();
  // Request nhận diện SĐT
  const { mutate } = useDetectPhone();
  useEffect(() => {
    if (!isLoggedIn() && !isDetected()) {
      mutate();
    }
  }, [mutate]);

  const runningProducts = products?.filter(
    (product) => new Date(product?.start_time).getTime() < currentDate
  );
  const upComingProduct = upnexts?.sort(
    (a, b) => Date.parse(a?.start_time) - Date.parse(b?.start_time)
  )?.[0];

  useEffect(() => {
    document.title = t("title.bid");
  }, [t]);

  // Chỉ hiển thị dải cờ từ 14:00 24/07/2026 tới 12:00 29/07/2026
  const flagsStart = new Date(2026, 6, 24, 14, 0, 0).getTime();
  const flagsEnd = new Date(2026, 6, 29, 12, 0, 0).getTime();
  const inFlagsWindow = () => {
    const now = Date.now();
    return now >= flagsStart && now < flagsEnd;
  };
  const [showFlags, setShowFlags] = useState(inFlagsWindow);

  useEffect(() => {
    // Kiểm tra mỗi giây, cập nhật hiển thị dải cờ theo thời gian thực
    const interval = setInterval(() => {
      const visible = inFlagsWindow();
      setShowFlags(visible);
      if (Date.now() >= flagsEnd) clearInterval(interval);
    }, 1000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flagsStart, flagsEnd]);

  return (
    <div className="home-page">
      {showFlags && (
      <div className="home-page-flags">
        <div className="home-page-flags__side home-page-flags__side--left">
          <img
            className="home-page-flags__group"
            src={flagGroup}
            alt=""
            aria-hidden="true"
          />
          <img
            className="home-page-flags__flag"
            src={flag}
            alt=""
            aria-hidden="true"
          />
        </div>
        <div className="home-page-flags__side home-page-flags__side--right">
          <img
            className="home-page-flags__flag"
            src={flag}
            alt=""
            aria-hidden="true"
          />
          <img
            className="home-page-flags__group"
            src={flagGroup}
            alt=""
            aria-hidden="true"
          />
        </div>
      </div>
      )}
      <div className="home-page-wrapper">
        <Row justify="center">
          <Col xs={24}>
            <Title level={2} className="home-page-title">
              {t("current_bid")}
            </Title>
            {upComingProduct && runningProducts?.length === 0 ? (
              <Row justify="center">
                <Col xs={24}>
                  <ProductDetail
                    product={upComingProduct}
                    showForm={!!user}
                    isUpcoming={
                      upComingProduct && Object.keys(upComingProduct) && true
                    }
                  />
                  <Information product={upComingProduct} />
                </Col>
              </Row>
            ) : (
              <Row justify="center">
                {runningProducts?.map((product, idx) => (
                  <Col xs={24} key={`product_${idx}`}>
                    {product?.status === 1 ? (
                      <Fragment>
                        <ProductDetail
                          product={product}
                          showForm={!!user}
                          isPotentialWinner={true}
                        />
                        <Information product={product} />
                      </Fragment>
                    ) : null}
                  </Col>
                ))}
              </Row>
            )}
            {products?.length === 0 && upnexts?.length === 0 ? (
              <EmptyData message={t("no_bid")} />
            ) : null}
          </Col>
        </Row>
        {/* {results?.length && results?.status !== 5 ? (
          <BidModal
            results={results?.filter((product) => product.status !== 5)}
          />
        ) : null} */}
        {/* <ChangeBid /> */}
      </div>
    </div>
  );
};

export default HomePage;
